import { useQuery } from "@tanstack/react-query";
import { GetNoticeDetailParams, getNoticeDetail } from "../api/notice";

const useGetNoticeDetail = ({ idx, isAdmin }: GetNoticeDetailParams) => {
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: ["noticeDetail", `idx-${idx}`],
    queryFn: () => getNoticeDetail({ idx, isAdmin }),

    retry: false,
    staleTime: 60 * 500, // 30초
  });

  return { data, isLoading, isSuccess };
};

export default useGetNoticeDetail;
